import api from "@/api";
// import * as XLSX from "xlsx"; // Make sure this is imported
export default {
  state: {
    searchCustomerForms: {},
    searchPotentialCustomerForms: {},
    searchLeadForms: {},

    policiesPerPage: {},
    currentPoliciesPage: 1,
    policiesLoading: false,
    searchPoliciesForms: {},
  },
  getters: {
    searchCustomerForms: (state) => state.searchCustomerForms,
    searchPotentialCustomerForms: (state) => state.searchPotentialCustomerForms,
    searchLeadForms: (state) => state.searchLeadForms,

    policiesPerPage: (state) => state.policiesPerPage,
    currentPoliciesPage: (state) => state.currentPoliciesPage,
    policiesLoading: (state) => state.policiesLoading,

    searchPoliciesForms: (state) => state.searchPoliciesForms,
  },
  mutations: {
    setSearchCustomerForms: (state, data) => {
      state.searchCustomerForms = data;
    },
    setSearchPotentialCustomerForms: (state, data) => {
      state.searchPotentialCustomerForms = data;
    },
    setSearchLeadForms: (state, data) => {
      state.searchLeadForms = data;
    },

    setPoliciesPerPage: (state, data) => {
      state.policiesPerPage = data;
    },
    setCurrentPoliciesPage: (state, data) => {
      state.currentPoliciesPage = data;
    },

    setPoliciesLoading: (state, data) => {
      state.policiesLoading = data;
    },

    setSearchPoliciesForms: (state, data) => {
      state.searchPoliciesForms = data;
    }
  },
  actions: {
    searchPotentialCustomer: async (_, phone) =>
      new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .get(`/v1/filter/potential-customers?phone=${phone}`)
          .then(
            (response) => {
              const [data] = response.data.data;
              resolve(data);
            },
            (err) => {
              reject(err);
            }
          );
      }),

    searchUsers: async ({ commit }, { searchKeywords, selectedTeam, active_users, page = 1, isExport = false }) => {
      if (!isExport) commit("setUsersLoading", true);

      try {
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (searchKeywords) params.append("search", searchKeywords);

        if (selectedTeam) {
          const teamIds = Array.isArray(selectedTeam)
            ? selectedTeam.map((t) => Number(t))
            : [Number(selectedTeam)];
          teamIds.forEach((id) => {
            params.append("teams[]", id);
          });
        }

        if (active_users !== undefined && active_users !== null && active_users !== "") {
          params.append("active_users", active_users);
        }

        if (isExport) params.append("export", "true");

        const queryString = params.toString();
        const url = `/v1/search/users${queryString ? `?${queryString}` : ""}`;

        const response = await api({ requiresAuth: true }).get(url, {
          responseType: isExport ? "blob" : undefined,
        });

        if (isExport) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Users_export.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          fileLink.remove();
          window.URL.revokeObjectURL(fileURL);
        } else {
          commit("setUsersPerPage", response.data);
        }
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        if (!isExport) commit("setUsersLoading", false);
      }
    },  

    getSearchCustomerForms: async ({ commit }, teamIds) => {
      try { 
        const idsArray = [].concat(teamIds);

        const query = idsArray
          .map(id => `teams[]=${encodeURIComponent(id)}`)
          .join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-customers?${query}`
        );

        commit("setSearchCustomerForms", data);
      } catch (err) {
        console.error(err);
      }
    },

    getSearchAddFamilyMemberForms: async ({ commit }) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/search-family"
        );
        commit("setSearchCustomerForms", data);
      } catch (err) {
        console.error(err);
      }
    },

    getSearchPotentialCustomerForms: async ({ commit }, teamIds) => {
      try {
        const query = teamIds.map(id => `teams[]=${encodeURIComponent(id)}`).join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-potential-customers?${query}`
        );
        commit("setSearchPotentialCustomerForms", data);
      } catch (err) {
        console.error(err);
      }
    },

    getSearchLeadForms: async ({ commit }, teamIds) => {
      try {
        const idsArray = [].concat(teamIds);

        const query = idsArray
          .map(id => `teams[]=${encodeURIComponent(id)}`)
          .join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-leads?${query}`
        );

        commit("setSearchLeadForms", data);
      } catch (err) {
        console.error(err);
      }
    },

    searchPotentialCustomers: async ({ commit }, { page, ...searchData }) => {
      commit("setCustomersLoading", true);
      try {
        const isSearching = Object.values(searchData).some(val =>
          (Array.isArray(val) ? val.length > 0 : (val !== "" && val !== null && val !== undefined))
        );

        let response;
        if (isSearching) {
          const url = page ? `/v1/search/potential-customers?page=${page}` : "/v1/search/potential-customers";
          response = await api({ requiresAuth: true }).post(url, searchData);
        } else {
          response = await api({ requiresAuth: true }).get(`/v1/potential-customers?page=${page}`);
        }

        commit("setCustomersPerPage", response.data);
      } catch (err) {
        console.error("Search Error:", err);
      } finally {
        commit("setCustomersLoading", false);
      }
    },
 
    searchCustomers: async ({ commit }, { page, ...searchData }) => {
      commit("setCustomersLoading", true);
      try {
        const isSearching = Object.values(searchData).some(val =>
          (Array.isArray(val) ? val.length > 0 : (val !== "" && val !== null && val !== undefined))
        );

        let response;
        if (isSearching || searchData.export) {
          const url = page ? `/v1/search/customers?page=${page}` : "/v1/search/customers";
          response = await api({ requiresAuth: true }).post(url, searchData, {
            responseType: searchData.export ? "blob" : "json"
          });
        } else {
          response = await api({ requiresAuth: true }).get(`/v1/customers?page=${page}`);
        }

        if (searchData.export) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const fileURL = window.URL.createObjectURL(blob);
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Customers_export.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
        } else {
          commit("setCustomersPerPage", response.data);
        }
      } catch (err) {
        console.error("Search/Export Error:", err);
      } finally {
        commit("setCustomersLoading", false);
      }
    },

    searchLeads: async ({ commit }, { page, ...searchData }) => {
      commit("setLeadsLoading", true);
      try {
        const isSearching = Object.values(searchData).some(val =>
          (Array.isArray(val) ? val.length > 0 : (val !== "" && val !== null && val !== undefined))
        );

        let response;
        if (isSearching || searchData.export) {
          const url = page ? `/v1/search/lead-customers?page=${page}` : "/v1/search/lead-customers";
          response = await api({ requiresAuth: true }).post(url, searchData, {
            responseType: searchData.export ? "blob" : "json"
          });
        } else {
          response = await api({ requiresAuth: true }).get(`/v1/lead-customers?page=${page}`);
        }

        if (searchData.export) {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const fileURL = window.URL.createObjectURL(blob);
          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "Leads_export.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);
        } else {
          commit("setLeadCustomersPerPage", response.data);
        }
      } catch (err) {
        console.error("Search/Export Error:", err);
      } finally {
        commit("setLeadsLoading", false);
      }
    },

    searchCustomerForFamily: async (_, { ...searchData }) =>
      new Promise((resolve, reject) => {
        api({ requiresAuth: true })
          .post(`/v1/filter/family-customers`,
            searchData
          )
          .then(
            (response) => {
              const data = response.data.data;
              resolve(data);
            },
            (err) => {
              reject(err);
            }
          );
    }),

    searchPolicies: async ({ commit }, { page, ...searchData }) => {
      commit("setPoliciesLoading", true);
      try {
        let response = null;
        const teamsPresent = (searchData.teams && searchData.teams.length > 0) || (searchData.selectedTeam && searchData.selectedTeam.length > 0);

        const isSearching =
          (searchData.search && searchData.search.trim() !== "") ||
          (searchData.agents && searchData.agents.length > 0) ||
          (searchData.companies && searchData.companies.length > 0) ||
          (searchData.branchCategories && searchData.branchCategories.length > 0) ||
          (searchData.policyStatuses && searchData.policyStatuses.length > 0) ||
          teamsPresent ||
          searchData.startDateFrom ||
          searchData.startDateTo ||
          searchData.endDateFrom ||
          searchData.endDateTo ||
          searchData.submitDateFrom ||
          searchData.submitDateTo;

        const isExport = !!(searchData.isExport || searchData.export);
 
        const payload = { ...searchData };
        if (!payload.teams && payload.selectedTeam) payload.teams = payload.selectedTeam;

        if (isSearching) {
          let url = page ? `/v1/search/policies?page=${page}` : "/v1/search/policies";
          if (isExport) url += (url.includes("?") ? "&" : "?") + "export=true";
          response = await api({ requiresAuth: true }).post(url, payload, {
            responseType: isExport ? "blob" : undefined,
          });
        } else {
          let url = page ? `/v1/policies?page=${page}` : "/v1/policies";
          if (isExport) url += (url.includes("?") ? "&" : "?") + "export=true";
          response = await api({ requiresAuth: true }).get(url, {
            responseType: isExport ? "blob" : undefined,
          });
        }

        if (isExport) {
          if (response && response.data) {
            const blob = new Blob([response.data], { type: response.headers && response.headers['content-type'] ? response.headers['content-type'] : 'application/octet-stream' });
            const fileURL = window.URL.createObjectURL(blob);
            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'Policies_export.xlsx');
            document.body.appendChild(fileLink);
            fileLink.click();
            document.body.removeChild(fileLink);
            window.URL.revokeObjectURL(fileURL);
          }
        } else {
          if (response && response.data) {
            commit("setPoliciesPerPage", response.data);
          }
        }
      } catch (err) {
        console.error("Vuex searchPolicies error:", err);
      } finally {
        commit("setPoliciesLoading", false);
      }
    },

    getSearchPoliciesForms: async ({ commit }, teamIds) => {
      try {
        const query = teamIds.map(id => `teams[]=${encodeURIComponent(id)}`).join("&");

        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          `/v1/partials/search-policies?${query}`
        );

        commit("setSearchPoliciesForms", data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};